export default __webpack_public_path__ + "static/media/Pierre.20cb980b.png";